export default __webpack_public_path__ + "static/media/ss.89c27869.png";